import { useTranslation } from 'next-i18next/pages';
import { resolveListingDataValue } from '@pkgs/components/utils/listingDataUtils';
import { type ListingPriceDescriptor } from '@pkgs/components';
import { Tooltip } from '@ev-tech/ui-core-components/Tooltip';
import { Copy } from '@ev-tech/ui-core-components/Copy';

import { TRANSLATION_NAMESPACE } from '@/i18n/config';

import styles from './PropertyPriceExtraInfoTooltip.module.css';

export const PropertyPriceExtraInfoTooltip = ({ extraPriceInfo }: { extraPriceInfo: ListingPriceDescriptor[] }) => {
  const { t: tPropertyExpose } = useTranslation(TRANSLATION_NAMESPACE.property_expose);
  const { t: tListingData } = useTranslation(TRANSLATION_NAMESPACE.listing_data);

  return (
    <Tooltip
      side="bottom"
      align="start"
      variant="light"
      label={tPropertyExpose('search.expose.propertyDetails.label.priceDetails')}
      closeLabel=""
    >
      <div className={styles.tooltipContentContainer}>
        {extraPriceInfo.map((info, index) => (
          <div className={styles.tooltipItemContainer} key={index} data-testid="expose-price-info-tooltip-line">
            <Copy className={styles.labelCopy} text={tListingData(info.labelKey)} size="m" as="span" />
            <div className={styles.priceLabelContainer}>
              <Copy className={styles.valueCopy} text={resolveListingDataValue(info, tListingData)} as="span" />
              {Boolean(info.convertedValue) && <Copy text={info.convertedValue} size="l" as="span" />}
            </div>
          </div>
        ))}
      </div>
    </Tooltip>
  );
};
